import { FormErrorMessage } from '@chakra-ui/react';
import {Select as ChakraSelect, FormLabel, FormControl, SelectProps as ChakraSelectProps } from '@chakra-ui/react';
import { forwardRef , ForwardRefRenderFunction} from 'react';
import { FieldError } from 'react-hook-form';


interface SelectInputProps  extends ChakraSelectProps {
    name: string;
    label?: string;
    error?: FieldError;
    desativado?: boolean;
    labelColor?: string;
    register?: any;
}

const SelectInputBase: ForwardRefRenderFunction<HTMLSelectElement, SelectInputProps> = ({register,name, label, labelColor, desativado, error = null, ...rest}, ref) => {
    return (
        <FormControl isInvalid={!!error}>
            {!!label && 
            <FormLabel 
                htmlFor={name}
                w="100%"
                color={labelColor ? labelColor : "gray.400"}
                fontSize="12px"
            >
                {label}
            </FormLabel>}
            <ChakraSelect 
              id={name}
              name={name} 
              focusBorderColor="primary"
              bgColor="white"
              borderRadius="2px"
              _disabled={{
                  bgColor:'gray.400',
                  borderColor:"gray.400",
                  cursor: 'not-allowed',
              }}
              {...register}
              _placeholder={{
                  color: desativado ? 'black' : 'gray.600',
                  opacity: desativado ? '0.4' : ''
              }}
              _hover={{
                bgColor: 'white',
              }}
              ref={ref}
              {...rest}
            >
                {rest.children}
            </ChakraSelect>


            {!!error && (
              <FormErrorMessage>
                {error.message}
              </FormErrorMessage>
            )}
          </FormControl>
    );
}

export const Select = forwardRef(SelectInputBase);